// 使用 Vue CLI 环境变量
export const baseURL = process.env.VUE_APP_API_URL || 
  (process.env.NODE_ENV === 'development' 
    ? "http://127.0.0.1:9000" 
    : "https://qidafang.com");

// 定义作者常量
export const AUTHORS = '煮酒正熟,辽东管宁,李天飞,与觚斋,娃娃鱼,赵学浩,杨文理,李靖岩,无为楼主,唯笑惟笑,白马将军上官迪,FFF团长,曹豫,释延德,杨沐梓,江宇舟,吕布姜维,卫迟,刀与笔,应弦吹笛,岳麓韶阳,哈士奇思维模拟器,安田秀彦,捣浆糊,欧小生,文若,静静的流浪猫,景谦,关2哥,芦苇,水镜,秦时明月,糗百小神仙,张小生,白菜,淮右咸鱼,夏至,刘寄奴,祁达方'
  .split(',');